import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useReviews } from "./useReviews";
import { useAuth } from "../context/AuthContext";
import { useRankings } from "./useRankings";
import api from "../utils/api";

export const useDashboardData = (entityId, range = "30d") => {
  const { user } = useAuth();

  const reviewsQuery = useReviews(entityId);

  const isTutor = user?.role === "tutor";
  const displayName = isTutor
    ? `${user?.firstName || ""} ${user?.lastName || ""}`.trim() || "Tutor"
    : user?.academyName || "Training Center";

  const dashboardQuery = useQuery({
    queryKey: ["dashboard", entityId, range],
    queryFn: async () => {
      if (!entityId) throw new Error("entityId required");
      const { data } = await api.get(`/dashboard/stats/${entityId}`, {
        params: { range },
      });
      return data;
    },
    enabled: !!entityId,
  });

  return {
    stats: dashboardQuery.data?.stats || {
      visibilityRate: "0%",
      pageVisitors: 0,
      whatsappClicks: 0,
    },
    changes: dashboardQuery.data?.changes || {
      visibilityRate: null,
      pageVisitors: null,
      whatsappClicks: null,
    },
    visitorsData: dashboardQuery.data?.visitorsData || [],
    pieData: dashboardQuery.data?.pieData || [
      { name: "Search Visibility", value: 0 },
      { name: "WhatsApp Link", value: 0 },
    ],
    // Real ranking data comes from useRankings(), not this hook.
    ratings: reviewsQuery.data || {
      average: 0,
      totalReviews: 0,
      5: 0,
      4: 0,
      3: 0,
      2: 0,
      1: 0,
    },
    isLoading: dashboardQuery.isLoading || reviewsQuery.isLoading,
    error: dashboardQuery.error || reviewsQuery.error,
  };
};
